import React, { useEffect } from "react";
import { motion } from "framer-motion";
import {
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import {
  Close,
  Campaign,
  EmojiEvents,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import * as Constant from "../../features/constant";

const CATEGORY_ICONS = {
  PROMOTION: Campaign,
  REWARDS_CLUB: EmojiEvents,
};

const PushNotificationToast = ({ notification, onDismiss }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const IconComponent = CATEGORY_ICONS[notification.category] || Campaign;

  // Auto-dismiss after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss(notification.id);
    }, 5000);

    return () => clearTimeout(timer);
  }, [notification.id, onDismiss]);

  const handleClick = () => {
    onDismiss(notification.id);
    navigate(
      Constant.getPath(`/messaging?category=${notification.category}`)
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 300, scale: 0.95 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 300, scale: 0.95 }}
      transition={{ type: "spring", damping: 25, stiffness: 300 }}
      style={{ marginBottom: 8 }}
    >
      <Box
        onClick={handleClick}
        sx={{
          width: 320,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          overflow: "hidden",
          cursor: "pointer",
          display: "flex",
          alignItems: "flex-start",
          p: 1.5,
          borderLeft: `4px solid ${theme.palette.primary.main}`,
          "&:hover": {
            boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: `${theme.palette.primary.main}15`,
            borderRadius: "50%",
            p: 1,
            mr: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <IconComponent
            sx={{
              color: theme.palette.primary.main,
              fontSize: 22,
            }}
          />
        </Box>

        <Box flex={1} minWidth={0}>
          <Typography
            variant="subtitle2"
            sx={{
              color: "#333",
              fontWeight: 600,
              fontSize: "13px",
              lineHeight: 1.3,
              mb: 0.3,
            }}
            noWrap
          >
            {notification.subject}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "#666",
              fontSize: "11px",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              lineHeight: 1.3,
            }}
          >
            {notification.preview}
          </Typography>
        </Box>

        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss(notification.id);
          }}
          sx={{
            ml: 0.5,
            p: 0.3,
            color: "#999",
            flexShrink: 0,
          }}
        >
          <Close sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </motion.div>
  );
};

export default PushNotificationToast;
